import { render, staticRenderFns } from "./agreementContent.vue?vue&type=template&id=4dc395ae&scoped=true"
var script = {}
import style0 from "./agreementContent.vue?vue&type=style&index=0&id=4dc395ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc395ae",
  null
  
)

export default component.exports